import { render, staticRenderFns } from "./plug-ad-add.vue?vue&type=template&id=26f394c4&scoped=true&"
import script from "./plug-ad-add.vue?vue&type=script&lang=js&"
export * from "./plug-ad-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f394c4",
  null
  
)

export default component.exports